/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from 'prop-types';
import { memo, forwardRef } from 'react';
import { jsx } from '@emotion/core';
const Circle = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  center,
  color,
  onMouseEnter,
  onMouseLeave,
  onTouchEnd,
  onTouchStart,
  className,
  radius,
  strokeColor,
  strokeWidth,
  name,
  quantity
}, ref) => {
  return jsx("ellipse", {
    ref: ref,
    cx: center,
    cy: center,
    fill: color,
    className: className,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onTouchEnd: onTouchEnd,
    onTouchStart: onTouchStart,
    rx: radius,
    ry: radius,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  }, name && jsx("title", null, name, ": ", quantity));
}));
Circle.propTypes = {
  className: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onTouchStart: PropTypes.func,
  center: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  radius: PropTypes.number.isRequired,
  strokeColor: PropTypes.string,
  strokeWidth: PropTypes.number,
  name: PropTypes.string,
  quantity: PropTypes.number
};
export default Circle;